<template id="partnerTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <div class="main-div" :class="formState.invalidShake?'invalid':''">
      <small
        class="--centered-block"
        v-if="(newPartner==null)"
      >Select a Partner From the list to edit. Press the Add New Button to add a new Partner</small>
      <div class="form-group col-12 col-sm-12" v-if="newPartner==null">
        <label class="pl-0 col-12 col-sm-12" for="partners">All Partners</label>
        <div class="p-0 mb-4 col-12 col-sm-12">
          <input
            class="form-control"
            type="text"
            maxlength="200"
            placeholder="Search All partners"
            v-model="partnersSearch"
          />
        </div>
        <b-form-select :disabled="formState.loading"
          class="col-12 col-sm-12"
          style="font-size:16px;"
          v-model="selectedPartnerId"
          :options="filteredPartners"
          :select-size="+10"
        ></b-form-select>
      </div>

      <div
        v-if="errors.length && formState.attempted && (!formState.loading)"
        class="col-12 col-sm-12"
      >
        <b class="w-100">Please correct the following error(s):</b>
        <ul>
          <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>

      <form class="partner-form">
        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newPartner==null)&&selectedPartnerData"
        >
          <legend>Existing Partner's Data</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name">Name</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedPartnerData.name"
                id="name"
                placeholder="ex. iThoob"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="discount">discount</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="number"
                max="100"
                min="1"
                v-model="selectedPartnerData.discount"
                id="discount"
                placeholder="discount"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="domain">domain</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedPartnerData.domain"
                id="domain"
                placeholder="ex. ithoob.com"
              />
              <small
                class="mb-4"
              >ex. If Your Company's E-mails is employee@ithoob.com - Your domain is ithoob.com</small>
            </div>
          </div>
        </fieldset>
        <div class="form-group col-12 col-sm-12">
          <div class="form-group col-12 col-sm-6" v-if="(newPartner==null)&&selectedPartnerData">
            <button
              type="button"
              v-on:click="deletePartner()"
              class="btn btn-danger"
              :disabled="formState.loading"
            >Delete Selected partner</button>
          </div>
          <div class="form-group col-12 col-sm-6" v-if="(newPartner==null)&&selectedPartnerData">
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="commitChanges()"
              class="btn btn-info"
            >Confirm Changes</button>
          </div>
        </div>

        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newPartner!=null)"
        >
          <legend>New Partner's Data</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name">Name</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="newPartner.name"
                id="name"
                placeholder="ex. iThoob"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="discount">discount</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="number"
                max="100"
                min="1"
                v-model="newPartner.discount"
                id="discount"
                placeholder="discount"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="domain">domain</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="newPartner.domain"
                id="domain"
                placeholder="ex. ithoob.com"
              />
              <small
                class="mb-4"
              >ex. If Your Company's E-mails is employee@ithoob.com Your domain is ithoob.com</small>
            </div>
          </div>
        </fieldset>

        <div class="col-12 col-sm-12" v-if="newPartner!=null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="saveNewPartner()"
            class="btn btn-info"
          >Save New Partner</button>
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="cancelNewPartner()"
            class="btn btn-danger"
          >Cancel New Partner</button>
        </div>

        <div class="col-12 col-sm-12" v-if="newPartner==null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="addNewPartner()"
            class="m-0 btn btn-success"
          >Add New Partner</button>
        </div>
      </form>
    </div>
  </div>
</template>



<!-- partner Template -->




<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  padding: 50px;
  width: 80%;
  div {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }

  .--centered-block {
    margin: 0 auto;
  }
}

//  0.82s
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { setTimeout } from "timers";
/* eslint-enable no-unused-vars*/
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "partnersCRUD",
  data() {
    return {
      newPartner: null, // If add partner button is pressed, this will be an object with a name, a domain and a discount.
      partnersSearch: "", // We search All partners Depending on this.
      selectedPartnerId: null, // Specifies The Id of the selected partner in the database
      selectedPartnerData: null, // Data is fetched from the backend using selectedPartnerId
      partners: [{ value: null, text: "Please select a partner to edit" }], // All partners (Fetched When component is mounted)
      filteredPartners: [
        { value: null, text: "Please select a partner to edit" }
      ], // All partners Filtered Using partnersSearch
      errors: [], // Form's errors
      formState: {
        loading: false,
        attempted: false,
        invalidShake: false
      } // Object Determining the Form's state
    };
  },
  watch: {
    // Computes the Filtered Array out of partners fetched from backend.
    partnersSearch: function() {
      this.filteredPartners = this.partners.filter(str => {
        return this.partnersSearch == ""
          ? true
          : str.text.toLowerCase().includes(this.partnersSearch.toLowerCase());
      });
      if (this.filteredPartners.length < 1)
        this.filteredPartners = [{ value: null, text: "No such result" }];
    },
    // When selectedPartnerId is changed, the partner's Data is fetched from the backend, If null is selected, the form is reset.
    selectedPartnerId: function() {
      if (this.selectedPartnerId) {
        this.fetchAllpartnerData(this.selectedPartnerId);
      } else {
        this.partiallyResetForm();
      }
    },
    newPartner: function() {
      this.checkForm();
    },
    selectedPartnerData: function() {
      this.checkForm();
    }
  },
  mounted() {
    this.fetchAllpartners();
  },
  methods: {
    // Partially resets the form
    partiallyResetForm: function() {
      this.cancelNewPartner();
      this.selectedPartnerData = null;
      this.selectedPartnerId = null;
      this.errors = [];
      this.formState = {
        loading: false,
        attempted: false,
        invalidShake: false
      };
    },
    checkForm: function() {
      this.errors = [];
      let domainRegex = /^([a-z0-9A-Z]\.)*[a-z0-9-]+\.([a-z0-9]{2,24})+(\.co\.([a-z0-9]{2,24})|\.([a-z0-9]{2,24}))*$/i;
      if (this.newPartner) {
        if (!this.newPartner.name)
          this.errors.push("Partner's Name is required");
        if (!this.newPartner.domain)
          this.errors.push("Partner's domain is required");
        if (this.newPartner.domain && !domainRegex.test(this.newPartner.domain))
          this.errors.push("Partner's domain's format is incorrect");
        if (!this.newPartner.discount)
          this.errors.push("Partner's Discount percentage is required");
        if (
          this.newPartner.discount &&
          (+this.newPartner.discount > 100 || +this.newPartner.discount <= 0)
        )
          this.errors.push(
            "Partner's Discount percentage must be more than 0 and less than or equal 100"
          );
      } else if (this.selectedPartnerData) {
        if (!this.selectedPartnerData.name)
          this.errors.push("Partner's Name is required");
        if (!this.selectedPartnerData.domain)
          this.errors.push("Partner's domain is required");
        if (
          this.selectedPartnerData.domain &&
          !domainRegex.test(this.selectedPartnerData.domain)
        )
          this.errors.push("Partner's domain's format is incorrect");
        if (!this.selectedPartnerData.discount)
          this.errors.push("Partner's Discount percentage is required");
        if (
          this.selectedPartnerData.discount &&
          (+this.selectedPartnerData.discount > 100 ||
            +this.selectedPartnerData.discount <= 0)
        )
          this.errors.push(
            "Partner's Discount percentage must be more than 0 and less than or equal 100"
          );
      }
    },
    fetchAllpartners() {
      this.formState.loading = true;
      return axios
        .post(
          `${herokuUrl}/dashboard/getAllpartners`,
          null,
          {
            headers: {
              Authorization: getCookie("user")
            }
          }
        )
        .then(res => {
          this.partners = [
            { value: null, text: "Please select a partner to edit" }
          ];
          res.data.partners.forEach(element => {
            this.partners.push({
              text: element.name,
              value: element.id
            });
          });
          this.filteredPartners = [...this.partners];
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Partners fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    fetchAllpartnerData(id) {
      this.formState.loading = true;
      return axios
        .post(
          `${herokuUrl}/dashboard/getAllPartnerData`,
          { id },
          {
            headers: {
              Authorization: getCookie("user")
            }
          }
        )
        .then(res => {
          this.partiallyResetForm();
          this.selectedPartnerData = { ...res.data.partnerData };
          this.selectedPartnerId = this.selectedPartnerData.id;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("partners fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    deletePartner() {
      if (confirm("Please confirm you want to DELETE the selected partner")) {
        this.formState.loading = true;
        return axios
          .post(
            `${herokuUrl}/dashboard/deletePartner`,
            {
              id: this.selectedPartnerData.id
            },
            {
              headers: {
                Authorization: getCookie("user")
              }
            }
          )
          .then(() => {
            alert("partner was deleted successfully");
            this.partiallyResetForm();
            this.fetchAllpartners();
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem deleting the selected partner " + err.response.data.message
              );
            }
          });
      }
    },
    commitChanges() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the selected partner with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .post(
              `${herokuUrl}/dashboard/editPartner`,
              this.selectedPartnerData,
              {
                headers: {
                  Authorization: getCookie("user")
                }
              }
            )
            .then(() => {
              alert("partner was Edited successfully");
              this.partiallyResetForm();
              this.fetchAllpartners();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected partner " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
    addNewPartner() {
      this.newPartner = {
        name: "",
        domain: "",
        discount: ""
      };
    },
    cancelNewPartner() {
      this.newPartner = null;
    },
    saveNewPartner() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (confirm("Please confirm you want to Add a new partner")) {
          this.formState.loading = true;
          return axios
            .post(
              `${herokuUrl}/dashboard/addNewPartner`,
              { ...this.newPartner },
              {
                headers: {
                  Authorization: getCookie("user")
                }
              }
            )
            .then(() => {
              alert("partner was Added successfully");
              this.partiallyResetForm();
              this.fetchAllpartners();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem adding the new partner " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    }
  },
  components: {
    appNavigation: Navigation
  }
};
</script>
